import { PartOfDay } from './part-of-day';

export interface AvailabilityDto {
  am?: boolean;
  pm?: boolean;
  slots?: HourSlot[];
  date: string;
}

export interface HourSlot {
  hour?: number;
  part_of_day?: PartOfDay;
  label?: string;
}
